import { create } from 'zustand';

interface AuthModalState {
    isOpen: boolean;
    redirectPath: string | null;
    pendingAction: (() => void) | null;
    openModal: (options?: { redirectPath?: string; pendingAction?: () => void }) => void;
    closeModal: () => void;
    executePendingAction: () => void;
}

export const useAuthModalStore = create<AuthModalState>((set, get) => ({
    isOpen: false,
    redirectPath: null,
    pendingAction: null,
    
    openModal: (options) => {
        set({
            isOpen: true,
            redirectPath: options?.redirectPath || null,
            pendingAction: options?.pendingAction || null,
        });
    },
    
    closeModal: () => {
        set({
            isOpen: false,
            redirectPath: null,
            pendingAction: null,
        });
    },
    
    executePendingAction: () => {
        const { pendingAction } = get();
        if (pendingAction) {
            pendingAction();
        }
        set({ pendingAction: null });
    },
}));
